<div class="row mt-2">
  <div class="col-12">
    <nav class="breadcrumb-one" aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="javascript:void(0);">
          <svg class="feather feather-home" fill="none" height="24" stroke="currentColor" stroke-linecap="round"
               stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24"
               xmlns="http://www.w3.org/2000/svg">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
            <polyline points="9 22 9 12 15 12 15 22"></polyline>
          </svg>
        </a></li>
        <li class="breadcrumb-item active" aria-current="page"><a href="/private/settings" translate>Settings</a></li>
        <li class="breadcrumb-item active" aria-current="page" translate>Privacy & Consent</li>
      </ol>
    </nav>
  </div>
</div>

<div class="consent-page" [hidden]="loading">

  <div class="consent-header">
    <h1 class="consent-title" dir="auto" translate>Privacy & Consent</h1>
    <p class="consent-subtitle" dir="auto">{{'You decide how we may use your personal data. You can change your choice at any time.' | translate}}</p>
  </div>

  <div class="consent-alert consent-alert-error" *ngIf="errorMessage">{{errorMessage}}</div>
  <div class="consent-alert consent-alert-success" *ngIf="referenceTicketId && !errorMessage">
    {{'Change submitted — reference' | translate}} <span dir="ltr">#{{referenceTicketId}}</span>
  </div>

  <!-- Marketing: self-service -->
  <div class="consent-card" *ngIf="loaded">
    <div class="consent-row">
      <div class="consent-row-text">
        <h2 class="consent-row-title" dir="auto" translate>Marketing communications</h2>
        <p class="consent-row-note" dir="auto">{{'Offers, new features and promotional messages. Service messages such as verification codes are always sent.' | translate}}</p>
      </div>
      <label class="consent-switch" [class.disabled]="saving">
        <input type="checkbox" id="marketingActive" [(ngModel)]="marketingActive" name="marketingActive"
               [attr.aria-label]="'Marketing communications' | translate"
               [disabled]="saving" (ngModelChange)="onMarketingToggle($event)">
        <span class="consent-slider"></span>
      </label>
    </div>
  </div>

  <!-- Processing: read-only; withdrawing it closes the account, so it goes through support -->
  <div class="consent-card" *ngIf="loaded">
    <div class="consent-row">
      <div class="consent-row-text">
        <h2 class="consent-row-title" dir="auto" translate>Processing of personal data</h2>
        <p class="consent-row-note" dir="auto">{{'Required to operate your account. Withdrawing this consent closes your Paylink account — contact support to request it.' | translate}}</p>
        <a class="consent-link" href="mailto:support@paylink.sa" dir="ltr">support&#64;paylink.sa</a>
      </div>
      <span class="consent-badge" [class.on]="processingActive">
        <!-- Not the bare 'Active' key: it already carries a masculine translation used for
             products elsewhere, and "الموافقة" needs the feminine form. -->
        {{(processingActive ? 'Consent active' : 'Consent not active') | translate}}
      </span>
    </div>
  </div>

  <!-- History -->
  <div class="consent-card" *ngIf="loaded && history.length">
    <div class="consent-card-head">
      <h2 translate>Recent changes</h2>
    </div>
    <div class="consent-history">
      <div class="consent-history-row" *ngFor="let e of history">
        <div class="consent-history-main">
          <span class="consent-history-type">{{typeLabel(e.consentType) | translate}}</span>
          <span class="consent-history-event" [class.given]="e.event === 'given'">{{eventLabel(e) | translate}}</span>
        </div>
        <div class="consent-history-meta">
          <span *ngIf="e.atDate" dir="ltr">{{e.atDate | date:'yyyy-MM-dd HH:mm'}}</span>
          <span *ngIf="e.channel" class="consent-history-channel">{{channelLabel(e.channel) | translate}}</span>
          <span *ngIf="e.dsrTicketId" class="consent-history-ref" dir="ltr">#{{e.dsrTicketId}}</span>
        </div>
      </div>
    </div>
  </div>

</div>

<div *ngIf="loading">
  <div class="d-flex">
    <div class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
  </div>
</div>
